import React from "react";

import Lamina13img from "../images/lamina13.png";
import Lamina13texto from "../images/lamina13texto.png";
import Lamina13fondo from "../images/lamina13fondo.png";
import Lamina13actividad from "../images/lamina13actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  actividadFondo: {
    backgroundImage: "url(" + Lamina13fondo + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    backgroundPosition: "bottom",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginBottom: "4em",
    "& div": {
      marginRight: "20%",
    },
    [theme.breakpoints.down("xs")]: {
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
    },
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina13 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 13: La identidad y la importancia del DNI"
        meta={[
          {
            property: "og:title",
            content: "Lámina 13: La identidad y la importancia del DNI",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content: "Todos tenemos derecho a un nombre desde que nacemos.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="13" color="blue" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="LA IDENTIDAD Y LA IMPORTANCIA DEL DNI" color="blue" />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p>
              Todos tenemos derecho a un nombre desde que nacemos. El nombre es
              muy importante porque por él nos llaman, nos ubican y nos
              reconocen. Eso se llama derecho a la identidad.
            </p>
            <p>
              El DNI es el documento que tenemos todas las personas nacidas en
              el Perú. Sirve para probar nuestra identidad, para identificar
              nuestro nombre y para ser reconocidos como integrantes de un
              grupo. Ese grupo es la comunidad peruana.
            </p>
            <p style={{ color: "rgb(236, 0, 140)" }}>
              <strong>
                Todas las personas nacidas en el Perú, desde el momento de su
                nacimiento, tienen derecho a su documento nacional de identidad
                (DNI). Con el DNI podemos acceder a otros derechos, por ejemplo,
                a un seguro de salud.
              </strong>{" "}
            </p>
            <p>¿A qué otros derechos podemos acceder al tener un DNI?</p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina13img} alt="La identidad" />
          </Grid>
        </Grid>
      </Container>
      <Container
        maxWidth="md"
        className={classes.contentLamina}
        style={{ marginTop: -80 }}
      >
        <div className={classes.actividadFondo}>
          <div className={classes.bloquetexto}>
            <img src={Lamina13texto} alt="Texto" />
          </div>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="blue" />
        <p>
          <strong>
            Imagina que trabajas en el Reniec y debes entregar el DNI a una
            persona.
          </strong>{" "}
          Entrevista a un miembro de tu familia y completa el esquema de DNI con
          sus datos. Dibuja el rostro en el primer recuadro blanco y una huella
          en el segundo.
        </p>
        <img src={Lamina13actividad} alt="Actividad lámina 13" />
        <p>
          <ul>
            <li>¿Qué datos se consignan en el DNI?</li>
            <li>¿Por qué crees que hay una foto y una huella digital?</li>
            <li>
              ¿Cuál es el número de tu DNI? Luego mira el número de DNI del
              resto de tu familia. ¿Por qué crees que cada persona tiene un
              número distinto de DNI?
            </li>
          </ul>
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-13.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 13: La identidad y la importancia del DNI'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Derechos y deberes de los ciudadanos"
        anteriorEnlace="/lamina-1-12"
        siguiente="Derechos de los niños y las niñas"
        siguienteEnlace="/lamina-1-14"
      />
    </>
  );
};

export default Lamina13;
